export default {
  /**
   * Export Excel
   * Converted data to excel file then trigger download
   * @param {String} data - Excel Data
   * @param {String} fileName - File Name + extention
   */
  export(data, fileName) {
    const fileURL = window.URL.createObjectURL(new Blob([data]));
    const fileLink = document.createElement("a");
    fileLink.href = fileURL;
    fileLink.setAttribute("download", fileName);
    document.body.appendChild(fileLink);
    fileLink.click();
  },
}